<div class="container">
	<div class="d-flex justify-content-center h-100">
		<div class="card">
            <div class="card-header">
				<h3>Sign Up</h3>
			</div>
			<div class="card-body">
				<form>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></span>
						</div>
						<input type="text" class="form-control" placeholder="Email Address" #userEmail required>
						
					</div>
					<div class="input-group form-group">
						<div class="input-group-prepend">
							<span class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></span>
						</div>
						<input type="password" class="form-control" placeholder="Password" #userPwd required>
					</div>
					<div class="form-group">
						<input type="submit" class="btn btn-block login_btn" value="Sign Up" (click)="authService.signUp(userEmail.value, userPwd.value)">
					</div>
				</form>
			</div>
			<div class="card-footer">
				<div class="d-flex justify-content-center">
					<span>Already have an account? <a class="redirect" routerLink="/login">Log In</a></span>
				</div>
			</div>
		</div>
	</div>
</div>

